import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Амерички Фудбал",
    Baseball: " Бејзбол",
    Basketball: "Кошарка",
    Boxing: "Бокс",
    Chess: "Шах",
    Cricket: "Крикет",
    Darts: "Пикадо",
    Entertainment: "Забава",
    "E-Sports": "Е-Спорт",
    Football: "Фудбал",
    "Formula 1": "Формула 1",
    "Gaelic Football": "Галски Фудбал",
    "Generic Sport": "Генерички Спорт",
    Golf: "Голф",
    "Greyhound Racing": "Трке хртова",
    Handball: "Рукомет",
    "Ice Hockey": "Хокеј на леду",
    IndyCar: "Индикар",
    MMA: "MMA",
    Nascar: "НАСКАР",
    Politics: "Политика",
    "Rugby League": "Рагби Лига",
    "Rugby Union": "Рагби Јунион",
    Snooker: "Снукер",
    "Table Tennis": "Стони Тенис",
    Tennis: "Тенис",
    "Virtual Football": "Виртуелни Фудбал",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} ће победити",
    WinFirstRound: "{name} ће добити прву рунду",
    FirstTouchdown: "{name} ће први поентирати полагањем",
    FirstTry: "{name} ће први поентирати полагањем есејом",
    TotalGoals: "{name} укупно голова",
    TotalRuns: "{name} укупно ранова",
    TotalPoints: "{name} укупно поена",
    TopBatsman: "{name} ће бити најбољи ударач",
    TopBowler: "{name} ће бити најбољи бацач",
    FirstScore: "{name} ће први дати гол"
  },
  PromoTexts: {
    Pick: "Направите своје опкладе",
    Bet: "Уплата",
    Pays: "Исплата"
  },
  DateTimeTexts: {
    Today: "Danas",
    Tomorrow: "Sutra",
    Live: "Uživo"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Направите своје опкладе",
    Return: "Исплата",
    Stake: "Уплата",
    Draw: "X"
  },
  H2HTexts: {
    // general
    "Per match": "по утакмици",
    H2H: "H2H",
    W: "П",
    D: "Н",
    L: "И",
    T: "Н",

    // soccer
    goals_scored: "Дати голови",
    shots: "Шутеви",
    shots_on_target: "Шутеви у оквир гола",
    ball_possession: "Посед лопте",
    goals_conceded: "Примљени голови",

    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing Stats",
    rushing_yards_per_game: "Rushing Yards",
    rushing_touchdowns: "Rushing Touchdowns (total)",
    rushing_percentage: "Rushing %",
    passing_stats: "Passing Stats",
    passing_yards_per_game: "Passing Yards",
    passing_touchdowns: "Passing Touchdowns (total)",
    passing_percentage: "Passing %"
  }
};
